/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './list_recommended_folders';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "FolderRecommendationService": {
                    "methods": {
                      "ListRecommendedFolders": {
                        "requestType": ".squareup.sfs.external.service.ListRecommendedFoldersRequest",
                        "responseType": ".squareup.sfs.external.service.ListRecommendedFoldersResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.FolderRecommendationService) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPC for recommending folders
 * --
 *
 * SOURCE FolderRecommendationService @ squareup/sfs/external/services/folder_recommendation/folder_recommendation_service.proto at 12:1
 */
export const FolderRecommendationService = $root.lookupService('squareup.sfs.external.service.FolderRecommendationService');